import { put, select, putResolve } from 'redux-saga/effects'

import { fieldsFetched, fetchFailed } from '../actions'

import getValidationRules from './getValidationRules'
import { getLivedata } from '../../../store/livedata'
import { fetchConditionInitialFields } from 'src/store/loan'

export default function* fetchFields({ payload, meta }) {
  try {
    // const { Data } = yield call(Loan.fetchConditionInitialFields, payload.params)

    //UPDATED API REQUEST loan_view_api page: conditions_curr
    const result = yield putResolve(
      fetchConditionInitialFields({
        LoanID: payload.params.ID,
        HashSum_LoanID_: payload.params.hash,
      }),
    )

    if (!fetchConditionInitialFields.fulfilled.match(result)) {
      throw { Error: { Message: result.payload } }
    }
    const Data = result.payload
    const livedata = yield select(getLivedata)

    const openDay = livedata.OpenDayStatus.Open_Day_Str
    const fields = { ...Data[0], ChangeDate: openDay }

    yield getValidationRules(fields, payload.ProductID, payload.ProductHash, meta)
    yield put(fieldsFetched(fields))

    if (meta.onSuccess) {
      meta.onSuccess()
    }
  } catch (error) {
    console.error(error)

    yield put(fetchFailed(error))
  }
}
